import React, { Component } from 'react'
import { Button, Modal } from 'react-bootstrap'
import ReactCrop from 'react-image-crop'
import 'react-image-crop/dist/ReactCrop.css'
import getPreSignedURLForImageService from '../../Services/Queries/getPreSignedURLForImageService'
import GetSections from '../../Services/Queries/GetSections'
import GetPeopleDetails from '../../Services/Queries/GetPeopleDetails'
import axios from 'axios'
import { v4 as uuidv4 } from 'uuid'
import CreatePeopleService from '../../Services/Mutations/CreatePeople'
import UpdatePeople from '../../Services/Mutations/UpdatePeople'
import CreateTemplate from '../../Services/Mutations/CreateTemplate'
import UpdateSectionPosition from '../../Services/Mutations/UpdateSectionPosition'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import AddList from './AddList'
import AddCollection from './AddCollection'
import AddPage from './AddPage'
import AddPeople from './AddPeople'
import DraggableSections from './DraggableSections'
import ListTemplates from '../../Services/Queries/ListTemplates'
import GetSectionDataMasterDetails from '../../Services/Queries/GetSectionDataMasterDetails'
import AwsConfig from '../../Config/AwsConfig'
import DeleteTemplate from '../../Services/Mutations/DeleteTemplate'
import { Link } from 'react-router-dom'
export default class CreatePeople extends Component {
  toastStyle = {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  }
  constructor(props) {
    super(props)
    this.peopleTemplates = ['default', 'subpeople']

    this.peopleType = [
      'Actor',
      'Actress',
      'Musician',
      'Singer',
      'Director',
      'Writer',
      'DOP',
      'Producer',
      'Other Film Professionals',
      'Sports Person',
      'Ex Sports Person',
      'Public Figure',
      'Politician',
      'Minister',
      'Entrepreneur',
      'Social Influencer',
      'Govt Official',
      'Doctor',
      'Others',
    ]
    this.state = {
      selectedPeopleTemplate: 'default',

      peopleID: '',
      newSectionDetails: [],
      sectionDetails: [],
      peopleType: 'Actor',
      selectedTab: 'Lists',
      listCollectionModalVisible: false,
      peopleName: '',
      peopleDescription: '',
      cropImage: false,
      croppedImage: '',
      limit: 20,
      personCoverImage: '',
      cropImage1: false,
      cropImage2: true,
      personProfileCroppedImage: '',
      personCoverCroppedImage: '',
      coverStoryTitle: '',
      coverStoryCardDescription: '',
      textColorOptions: [
        { item: 'white', id: 1, value: '#ffffff' },
        { item: 'black', id: 2, value: '#000000' },
        { item: 'grey', id: 3, value: '#bdbdbd' },
      ],
      selectedTextColorOption: '#ffffff',
      imageFor: '',
      peopleCoverImages: [],
      peopleProfileImages: [],
      titleOptionsVisibility: false,
      contentPosition: '50',
      displayTitleBackground: false,
      expandedImage: null,
      expanded: true,
      files: [],
      templateToDelete: '',
      imageFor: '',
      src: null,
      crop: {
        unit: '%',
        width: 30,

        aspect: 16 / 9,
      },
      src2: null,
      crop2: {
        unit: '%',
        width: 30,
        aspect: 1,
      },
      selectedTemplates: [],
      selectedSections: [],
      templatesModalVisible: false,
      templatesList: [],
      templatelimit: 10,
      templatenextToken: null,
      templateDetailsModal: false,
      templateName: '',
    }
  }
  handlePeopleName = (e) => {
    const name = e.target.value
    this.setState({ peopleName: name })
  }
  handlePeopleDescription = (e) => {
    const name = e.target.value
    this.setState({ peopleDescription: name })
  }
  selectType = (e) => {
    const peopleType = e.target.value
    console.log(peopleType, 'peopleType')
    this.setState({ peopleType: peopleType })
  }
  getTemplates = async () => {
    const input = {
      limit: this.state.templatelimit,
      templateType: 'peopleTemplate',
    }
    console.log(input, 'inputaaa templatesss')

    const data = await ListTemplates(input)
    console.log(data, 'dataaaa templatesss')
    this.setState({
      templatesList: data.items ? data.items : [],
      templatenextToken: data.nextToken,
    })
  }
  getNextTemplates = async () => {
    const { limit, filtered } = this.state
    const input = {
      limit: this.state.templatelimit,
      nextToken: this.state.templatenextToken,
      templateType: 'peopleTemplate',
    }

    const data = await ListTemplates(input)
    console.log(data.items, 'next dataaaaaaaaaaaaaaaaaaaa')
    if (data.nextToken == null) {
      this.setState({
        templatesList: [...this.state.templatesList, ...data.items],
        templatenextToken: null,
      })
    } else {
      this.setState({
        templatesList: [...this.state.templatesList, ...data.items],
        templatenextToken: data.nextToken,
      })
    }
  }
  loadMore = async () => {
    await this.getNextTemplates()
  }
  openTemplateListModal = () => {
    this.getTemplates()
    this.setState({ templatesModalVisible: true })
  }
  closeTemplatesModal = () => {
    this.setState({ templatesModalVisible: false })
  }
  openTemplateDetailsModal = () => {
    this.setState({ templateDetailsModal: true })
  }
  closeTemplateDetailsModal = () => {
    this.setState({ templateDetailsModal: false })
  }
  openDeleteTemplateModal = (templateToDelete) => {
    this.setState({ deleteTemplateModal: true, templateToDelete: templateToDelete })
  }
  closeDeleteTemplateModal = () => {
    this.setState({ deleteTemplateModal: false })
  }
  deleteTemplate = async () => {
    const input = {
      templateValue: this.state.templateToDelete,
    }
    this.setState({ deleteTemplateModal: false })

    const data = await DeleteTemplate(input)
    if (data.statusCode == '200') {
      const refreshedTemplatesList = this.state.templatesList.filter((data) => {
        return data.SK != this.state.templateToDelete
      })
      this.setState({ templatesList: refreshedTemplatesList })
      toast.success('Template Deleted Successfully', this.toastStyle)
    } else {
      toast.success('Failed to delete Template ', this.toastStyle)
    }
    console.log(data, 'dataaaaaaaa')
  }
  addSectionsAndCloseModal = () => {
    const { sectionDetails, selectedSections } = this.state
    const merged = [].concat.apply([], selectedSections)
    const finalArray = []
    merged.map((item, index) => {
      const input = {
        sectionLabel_Te: item.sectionLabel_Te ? item.sectionLabel_Te : '',
        sectionLabel_En: item.sectionLabel_En ? item.sectionLabel_En : '',
        sectionLabel_Hi: item.sectionLabel_Hi ? item.sectionLabel_Hi : '',
      }
      if (item.SK.includes('list#')) {
        input.listValue = item
        input.sectionType = 'list'
        input.listName_En = item.listName_En
        input.listName_Hi = item.listName_Hi
        input.listName_Te = item.listName_Te
      } else {
        input.collectionValue = item
        input.sectionType = 'collection'
      }
      input.sectionColumns = item.sectionColumns
      input.sectionConfigType = item.sectionConfigType
      input.sectionScroll = item.sectionScroll
      input.showAsSubPage = item.showAsSubPage
      input.displayAfter = item.displayAfter
      input.sortBy = item.sortBy

      finalArray.push(input)
    })

    this.setState({
      newSectionDetails: finalArray,
      sectionDetails: [...sectionDetails, ...finalArray],
      templatesModalVisible: false,
    })
  }
  saveTemplate = async () => {
    this.setState({ templateDetailsModal: false })
    const urlParams = window.location.href.split('?')
    let peopleValue = ''
    if (urlParams && urlParams[1]) {
      peopleValue = 'people#' + urlParams[1]
    }
    const input = {
      PK: peopleValue,
      limit: this.state.limit,
    }
    const data = await GetSections(input)
    let sections = []
    let sectionsArr = []
    data &&
      data.items.map((item, index) => {
        if (item.SK.includes('list#') || item.SK.includes('collection#')) {
          sections.push(item.SK)
          let sectionDataObj = {}
          sectionDataObj.sectionValue = item.SK
          sectionDataObj.sectionLabel_En = item.sectionLabel_En
          sectionDataObj.sectionLabel_Te = item.sectionLabel_Te
          sectionDataObj.sectionLabel_Hi = item.sectionLabel_Hi
          sectionDataObj.sortBy = item.sortBy
          sectionDataObj.sectionScroll = item.sectionScroll
          sectionDataObj.sectionColumns = item.sectionColumns
          sectionDataObj.sectionConfigType = item.sectionConfigType
          sectionDataObj.showAsSubPage = item.showAsSubPage
          sectionDataObj.displayAfter = item.displayAfter
          sectionDataObj.sectionPosition = index + 1
          sectionsArr.push(sectionDataObj)
        }
      })
    const createTemplateInput = {
      templateName: this.state.templateName,
      sectionsArray: sectionsArr,
      sections: sections,
      templateType: 'peopleTemplate',
    }
    console.log(createTemplateInput, 'createTemplateInput')
    const response = await CreateTemplate(createTemplateInput)
    if (response.statusCode == '200') {
      toast.success('Template Saved Successfully', this.toastStyle)
    } else {
      toast.success('Failed to save template', this.toastStyle)
    }
    console.log(response, 'response================')
  }
  selectTemplate = (value) => {
    const index = this.state.selectedTemplates.findIndex((item) => item == value)
    const selectedTemplates = this.state.selectedTemplates
    const selectedSections = this.state.selectedSections
    if (index == -1) {
      this.state.templatesList.map((template, tempIndex) => {
        if (template.templateName == value && template.sections) {
          selectedSections.push(template.sectionsMasterData)
        }
      })
      selectedTemplates.push(value)
    } else {
      selectedTemplates.splice(index, 1)
      selectedSections.splice(index, 1)
    }
    this.setState({ selectedTemplates: selectedTemplates })
  }
  selectPeopleTemplate = (peopleTemplate) => {
    this.setState({ selectedPeopleTemplate: peopleTemplate })
  }
  handleCreatePeople = async () => {
    //add sections to people
    const urlParams = window.location.href.split('?')

    const input = {
      peopleName: this.state.peopleName,
      peopleDescription: this.state.peopleDescription,
      peopleCoverImage: this.state.peopleCoverImages[0].key
        ? this.state.peopleCoverImages[0].key.substring(
            this.state.peopleCoverImages[0].key.indexOf('public')
          )
        : this.state.peopleCoverImages[0].substring(
            this.state.peopleCoverImages[0].indexOf('public')
          ),
      peopleTemplate: this.state.selectedPeopleTemplate,
      peopleType: this.state.peopleType,
    }
    if (this.state.peopleProfileImages.length) {
      input.peopleProfileImage = this.state.peopleProfileImages[0].key
        ? this.state.peopleProfileImages[0].key.substring(
            this.state.peopleProfileImages[0].key.indexOf('public')
          )
        : this.state.peopleProfileImages[0].substring(
            this.state.peopleProfileImages[0].indexOf('public')
          )
    }
    if (urlParams && urlParams[1]) {
      input.SK = this.state.peopleDetails.SK
      input.PK = this.state.peopleDetails.PK
    } else {
      let uniqueID = ''
      uniqueID = await uuidv4()
      input.peopleValue = uniqueID
    }

    console.log(input, 'inputaaaaaaaaaaa')
    const data =
      urlParams && urlParams[1] ? await UpdatePeople(input) : await CreatePeopleService(input)

    console.log(data, 'dataaaaaaaaaaaa')

    if (data) {
      if (
        urlParams && urlParams[1]
          ? data.statusCode == 'A253'
          : data.statusDetails.statusCode == 'A252'
      ) {
        if (urlParams && urlParams[1]) {
          toast.success('Peope Updated Successfully', this.toastStyle)
        } else {
          window.open('editPeople?' + data.addedDetails.SK.split('people#')[1])
          toast.success('Peope Created Successfully', this.toastStyle)
        }
        setTimeout(() => {
          window.location.reload()
        }, 2000)
      } else {
        urlParams && urlParams[1]
          ? toast.error('Failed to update people', this.toastStyle)
          : toast.success('Failed to created people', this.toastStyle)
      }
    } else {
      toast.error('Oops Something Went Wrong', this.toastStyle)
    }
  }

  GetDate = () => {
    return (
      new Date().getFullYear() +
      '' +
      ('0' + (new Date().getMonth() + 1)).slice(-2) +
      ('0' + new Date().getDate()).slice(-2)
    )
  }
  buttonVisibilityFunc = () => {
    const visibility =
      this.state.peopleName != '' &&
      this.state.peopleType != '' &&
      this.state.peopleCoverImages.length > 0 &&
      this.state.peopleDescription &&
      this.state.peopleProfileImages.length > 0
    return visibility
  }
  uploadSelectedImage = async (imageFor, crop) => {
    const fileName =
      imageFor == 'peopleCoverImages'
        ? this.state.selectedCoverImage.name
        : this.state.selectedProfileImage.name
    const key = fileName + '_' + Math.floor(Date.now() / 1000) + '.png'

    const path = 'public/' + this.GetDate() + '/PeopleImages/' + key
    const params = {
      key: path,
      mimeType:
        imageFor == 'peopleCoverImages'
          ? this.state.selectedCoverImage.type
          : this.state.selectedProfileImage.type,
    }
    const preSignedURLObject = await getPreSignedURLForImageService(params)
    const signedURLObject = JSON.parse(preSignedURLObject.signedObject)
    const signedURL = signedURLObject.data['url']
    try {
      const formData = new FormData()
      Object.keys(signedURLObject.data.fields).forEach((key) => {
        formData.append(key, signedURLObject.data.fields[key])
      })
      const croppedFile =
        this.state.imageFor == 'peopleCoverImages'
          ? this.state.personCoverCroppedImage
          : this.state.personProfileCroppedImage
      const originalFile =
        this.state.imageFor == 'peopleCoverImages'
          ? this.state.selectedCoverImage
          : this.state.selectedProfileImage
      // Actual file has to be appended last.
      if (crop) {
        formData.append('file', croppedFile)
      } else {
        formData.append('file', originalFile)
      }
      const response = await axios({
        method: 'post',
        url: signedURL,
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      let selectedImageValue = ''
      if (this.state.imageFor == 'peopleCoverImages') {
        selectedImageValue = this.state.croppedImageUrl
          ? this.state.croppedImageUrl
          : this.state.src
      } else {
        selectedImageValue = this.state.croppedImageUrl2
          ? this.state.croppedImageUrl2
          : this.state.src2
      }

      if (response.status) {
        const imageObj = {
          imageValue: selectedImageValue,
          key: path,
          copyRight: false,
          copyRightText: '',
          shareImage: false,
        }
        this.uploadImages(imageFor, imageObj)
      }
    } catch (err) {
      console.warn(err, 'err')
    }
  }
  uploadImages = (imageFor, imageObj) => {
    const { peopleCoverImages, peopleProfileImages } = this.state
    if (imageFor == 'peopleCoverImages') {
      peopleCoverImages.push(imageObj)
      this.setState({ peopleCoverImages: peopleCoverImages })
    } else {
      peopleProfileImages.push(imageObj)
      this.setState({ peopleProfileImages: peopleProfileImages })
    }
  }

  removeSelectedImage = (imageFor) => {
    if (imageFor == 'peopleCoverImages') {
      this.setState({
        cropImage1: false,
        src: null,
        peopleCoverImages: [],
        crop: {
          unit: '%',
          width: 30,
          aspect: 16 / 9,
        },
        croppedImageUrl: '',
        selectedCoverImage: '',
      })
    } else {
      this.setState({
        src2: '',
        peopleProfileImages: [],

        croppedImageUrl2: '',
        selectedProfileImage: '',
      })
    }
  }
  onSelectFile = (e) => {
    this.setState({ imageFor: 'peopleCoverImages' })
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader()
      reader.addEventListener('load', () => this.setState({ src: reader.result }))
      reader.readAsDataURL(e.target.files[0])
      this.setState({
        cropImage1: false,
        peopleCoverImages: [],
        selectedCoverImage: e.target.files[0],
        // crop: false,
        croppedImageUrl: '',
        personCoverCroppedImage: '',
      })
    }
  }
  onSelectFile2 = (e) => {
    this.setState({ imageFor: 'peopleProfileImages' })
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader()
      reader.addEventListener('load', () => this.setState({ src2: reader.result }))
      reader.readAsDataURL(e.target.files[0])
      this.setState({
        cropImage2: false,

        peopleProfileImages: [],
        selectedProfileImage: e.target.files[0],
        // crop2: false,
        croppedImageUrl2: '',
        personProfileCroppedImage: '',
      })
    }
  }

  // If you setState the crop in here you should return false.
  onImageLoaded = (image) => {
    this.imageRef = image
  }

  onCropComplete = (crop) => {
    this.makeClientCrop(crop)
  }

  onCropChange = (crop, percentCrop) => {
    // You could also use percentCrop:
    // this.setState({ crop: percentCrop });
    this.setState({ crop })
  }
  onImageLoaded2 = (image) => {
    this.imageRef2 = image
  }

  onCropComplete2 = (crop) => {
    this.makeClientCrop2(crop)
  }

  onCropChange2 = (crop, percentCrop) => {
    // You could also use percentCrop:
    // this.setState({ crop: percentCrop });
    this.setState({ crop2: crop })
  }

  async makeClientCrop(crop) {
    if (this.imageRef && crop.width && crop.height) {
      const croppedImageUrl = await this.getCroppedImg(this.imageRef, crop, 'newFile.jpeg')
      this.setState({ croppedImageUrl })
    }
  }
  async makeClientCrop2(crop) {
    if (this.imageRef2 && crop.width && crop.height) {
      const croppedImageUrl = await this.getCroppedImg(this.imageRef2, crop, 'newFile.jpeg')
      this.setState({ croppedImageUrl2: croppedImageUrl })
    }
  }

  getCroppedImg(image, crop, fileName) {
    const canvas = document.createElement('canvas')
    const pixelRatio = window.devicePixelRatio
    const scaleX = image.naturalWidth / image.width
    const scaleY = image.naturalHeight / image.height
    const ctx = canvas.getContext('2d')

    canvas.width = crop.width * pixelRatio * scaleX
    canvas.height = crop.height * pixelRatio * scaleY

    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0)
    ctx.imageSmoothingQuality = 'high'

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width * scaleX,
      crop.height * scaleY
    )

    return new Promise((resolve, reject) => {
      canvas.toBlob(
        (blob) => {
          if (!blob) {
            //reject(new Error('Canvas is empty'));
            console.error('Canvas is empty')
            return
          }
          blob.name = fileName
          window.URL.revokeObjectURL(this.fileUrl)
          this.fileUrl = window.URL.createObjectURL(blob)
          if (this.state.imageFor == 'peopleCoverImages') {
            this.setState({ personCoverCroppedImage: blob })
          } else {
            this.setState({ personProfileCroppedImage: blob })
          }
          resolve(this.fileUrl)
        },
        'image/jpeg',
        1
      )
    })
  }
  getSectionDetails = async () => {
    const urlParams = window.location.href.split('?')
    let peopleValue = ''
    if (urlParams && urlParams[1]) {
      peopleValue = 'people#' + urlParams[1]
    }
    const input = {
      PK: peopleValue,
      limit: this.state.limit,
    }
    console.log(input, 'inputaaa sectionsss=======')

    const data = await GetSections(input)
    console.log(data, 'dataaaa sectionsss')

    if (data && data.items) {
      const promises = data.items.map(async (item) => {
        if (item.SK.includes('section#')) {
          const inputForMasterData = {
            PK: item.PK,
            SK: item.SK,
            type: item.GSIRecordType,
          }
          const data = await GetSectionDataMasterDetails(inputForMasterData)
          if (data && data.items) {
            item.sectionDetails = data.items.filter(Boolean)
          }
        }
        return item
      })
      const finalItems = await Promise.all(promises)
      this.setState({
        sectionDetails: finalItems,
        nextToken: data.nextToken,
        endReached: data.nextToken != null ? false : true,
      })
      this.isServiceRunning = false
    }
  }
  getNextSectionDetails = async () => {
    const urlParams = window.location.href.split('?')

    const peopleValue = urlParams && urlParams[1]
    const input = {
      PK: peopleValue,
      limit: this.state.limit,
      nextToken: this.state.nextToken,
    }

    const data = await GetSections(input)
    this.setState({
      sectionDetails: [...this.state.sectionDetails, ...data.items],
      nextToken: data.nextToken,
      endReached: data.nextToken != null ? false : true,
    })
  }

  componentDidMount = async () => {
    const urlParams = window.location.href.split('?')
    if (urlParams && urlParams[1]) {
      const input = { peopleValue: 'people#' + urlParams[1] }
      const peopleDetails = await GetPeopleDetails(input)
      const cdnurl = AwsConfig.cdn_url
      const profileImage = peopleDetails.peopleProfileImage
        ? !peopleDetails.peopleProfileImage.includes(cdnurl)
          ? cdnurl + peopleDetails.peopleProfileImage
          : peopleDetails.peopleProfileImage
        : ''

      this.setState({
        peopleDetails: peopleDetails,
        src: peopleDetails.peopleCoverImage,
        peopleCoverImages: [peopleDetails.peopleCoverImage],
        src2: profileImage,
        peopleProfileImages: profileImage ? [profileImage] : [],
        peopleName: peopleDetails.peopleName,
        peopleType: peopleDetails.peopleType,
        selectedPeopleTemplate: peopleDetails.peopleTemplate
          ? peopleDetails.peopleTemplate
          : 'default',

        peopleDescription: peopleDetails.peopleDescription,
        selectedPeopleTemplate: peopleDetails.peopleTemplate,
      })
      this.setState({ peopleId: urlParams[1] })
      this.getSectionDetails()
    }
  }
  setTab = (tabValue) => {
    this.setState({ selectedTab: tabValue })
  }
  closeListCollectionModal = () => {
    // this.getSectionDetails()

    this.setState({ listCollectionModalVisible: false })
  }
  addPeopleSections = (input) => {
    const sections = this.state.sectionDetails
    sections.push(input)
    this.setState({ sectionDetails: sections })
  }
  updatePeopleSections = (sections) => {
    this.setState({ sectionDetails: sections })
  }
  refreshSections = () => {
    this.getSectionDetails()
  }
  displayToast = (message, type) => {
    if (type == 'success') {
      toast.success(message, this.toastStyle)
    } else {
      toast.error(message, this.toastStyle)
    }
  }
  updateSortedOrder = async (sortedSections) => {
    const urlParams = window.location.href.split('?')

    const sectionValues = []
    const peopleValue = urlParams && urlParams[1]
    sortedSections.map((item, index) => {
      item.sectionPosition = index + 1
      sectionValues.push({
        sectionValue: item.SK,
        sectionPosition: index + 1,
      })
    })
    // console.log(this.state.sectionDetails, 'state.sectionDetails')

    this.setState({
      sectionDetails: sortedSections,
    })
    const input = {
      PK: 'people#' + peopleValue,
      sectionValues: sectionValues,
    }
    console.log(input, 'inputtttt')
    const data = await UpdateSectionPosition(input)
    console.log(data, 'dataaa')
    // if (data.statusCode == 'A279') {
    //   this.setState({
    //     snackbarType: 'success',
    //     snackbarvisible: true,
    //     snackbarInfo: 'sectionSortedSuccessfully',
    //   })
    // }
  }
  removeSection = (itemTodelete) => {
    // const index = this.state.sectionDetails.findIndex((section) => section.SK == itemTodelete.SK)
    const sectionDetails = this.state.sectionDetails
    sectionDetails.splice(itemTodelete, 1)
    this.setState({
      sectionDetails: sectionDetails,
    })
  }
  UpdateSectionDetails = (itemIndex, label_Hi, label_Te, label_En, sectionConfig) => {
    // const index = this.state.sectionDetails[itemIndex]
    const sectionDetails = this.state.sectionDetails
    sectionDetails[itemIndex].sectionLabel_Te = label_Te
    sectionDetails[itemIndex].sectionLabel_Hi = label_Hi
    sectionDetails[itemIndex].sectionLabel_En = label_En
    sectionDetails[itemIndex].sectionColumns = sectionConfig.sectionColumns
    sectionDetails[itemIndex].sectionScroll = sectionConfig.sectionScroll
    sectionDetails[itemIndex].displayAfter = sectionConfig.displayAfter
    sectionDetails[itemIndex].showAsSubPage = sectionConfig.showAsSubPage
    sectionDetails[itemIndex].sectionConfigType = sectionConfig.sectionConfigType
    sectionDetails[itemIndex].sortBy = sectionConfig.sortBy

    this.setState({
      sectionDetails: sectionDetails,
    })
  }
  handleTemplateName = (e) => {
    const name = e.target.value
    this.setState({ templateName: name })
  }
  renderTemplateDetailsModal = () => {
    const { templateDetailsModal } = this.state
    return (
      <div>
        <Modal show={templateDetailsModal} onHide={() => this.closeTemplateDetailsModal()}>
          <Modal.Body>
            <text for='text'>Template Name</text>
            <div>
              <input
                type='text'
                onChange={(value) => {
                  this.handleTemplateName(value)
                }}
                value={this.state.templateName}
                placeholder='Please Enter Template Name'
              ></input>
            </div>
          </Modal.Body>
          <Modal.Footer>
            {this.state.templateName ? (
              <Button onClick={() => this.saveTemplate()}>Save Template</Button>
            ) : (
              <Button disabled>Save Template</Button>
            )}
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
  renderDeleteTemplateModal = () => {
    const { deleteTemplateModal } = this.state
    return (
      <div>
        <Modal show={deleteTemplateModal} onHide={() => this.closeDeleteTemplateModal()}>
          <Modal.Header>
            <label>Are You Sure You want to delete this template?</label>
          </Modal.Header>
          <Modal.Footer>
            <Button onClick={() => this.deleteTemplate()}>Delete</Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
  renderListCollectionModal = () => {
    const { listCollectionModalVisible, selectedTab } = this.state
    const urlParams = window.location.href.split('?')

    return (
      <div>
        <Modal show={listCollectionModalVisible} onHide={() => this.closeListCollectionModal()}>
          <Modal.Body>
            <Tabs
              id='controlled-tab-example'
              activeKey={selectedTab}
              onSelect={(k) => this.setTab(k)}
              className='mb-3'
            >
              <Tab eventKey='Lists' title='Lists'>
                <AddList
                  addPeopleSections={this.addPeopleSections}
                  selectedTab={this.state.selectedTab}
                  peopleValue={`people#${urlParams && urlParams[1]}`}
                  type='people'
                  sectionPosition={
                    this.state.sectionDetails && this.state.sectionDetails.length + 1
                  }
                  closeListCollectionModal={this.closeListCollectionModal}
                />
              </Tab>
              <Tab eventKey='Collections' title='Collections'>
                <AddCollection
                  addPeopleSections={this.addPeopleSections}
                  selectedTab={this.state.selectedTab}
                  peopleValue={`people#${urlParams && urlParams[1]}`}
                  type='people'
                  sectionPosition={
                    this.state.sectionDetails && this.state.sectionDetails.length + 1
                  }
                  closeListCollectionModal={this.closeListCollectionModal}
                />
              </Tab>
              <Tab eventKey='Page' title='Page'>
                <AddPage
                  addPeopleSections={this.addPeopleSections}
                  selectedTab={this.state.selectedTab}
                  peopleValue={`people#${urlParams && urlParams[1]}`}
                  type='people'
                  sectionPosition={
                    this.state.sectionDetails && this.state.sectionDetails.length + 1
                  }
                  closeListCollectionModal={this.closeListCollectionModal}
                />
              </Tab>
              <Tab eventKey='People' title='People'>
                <AddPeople
                  addPeopleSections={this.addPeopleSections}
                  selectedTab={this.state.selectedTab}
                  peopleValue={`people#${urlParams && urlParams[1]}`}
                  type='people'
                  sectionPosition={
                    this.state.sectionDetails && this.state.sectionDetails.length + 1
                  }
                  closeListCollectionModal={this.closeListCollectionModal}
                  pageValue={urlParams && urlParams[1]}
                />
              </Tab>
            </Tabs>
          </Modal.Body>
        </Modal>
      </div>
    )
  }
  renderTemplates = () => {
    const { templatesList, templatesModalVisible, selectedTemplates, selectedSections } = this.state

    return (
      <div class=' row col-md-12'>
        <div>
          <Modal show={templatesModalVisible} onHide={() => this.closeTemplatesModal()}>
            <Modal.Header>
              <label>Templates List</label>
            </Modal.Header>
            <Modal.Body>
              {templatesList.length > 0 &&
                templatesList.map((item, index) => {
                  return (
                    <div
                      class='col-md-9'
                      style={{
                        marginBottom: '5px',
                      }}
                    >
                      <div style={{ marginRight: 10 }}>
                        <input
                          value={item.templateName}
                          type='checkbox'
                          checked={selectedTemplates.includes(item.templateName)}
                          onClick={() => {
                            this.selectTemplate(item.templateName)
                          }}
                        ></input>
                        <text for={item.templateName}>
                          {item.templateName}
                          {`(${item.sections.length})`}
                        </text>
                        <i
                          onClick={() => this.openDeleteTemplateModal(item.SK)}
                          class='fas fa-trash'
                          style={{ marginLeft: '10px' }}
                        />
                      </div>
                    </div>
                  )
                })}
            </Modal.Body>
            <Modal.Footer>
              {this.state.templatenextToken != null && (
                <Button onClick={this.loadMore} type='button' className='load-more'>
                  Load more
                </Button>
              )}
              <Button onClick={() => this.addSectionsAndCloseModal()}>Ok</Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    )
  }
  renderGeneralPeopleOptions = () => {
    const {
      peopleType,
      peopleCoverImages,
      peopleProfileImages,
      src,
      crop,
      croppedImageUrl,
      cropImage1,
      src2,
      crop2,
      croppedImageUrl2,
      cropImage2,
    } = this.state
    return (
      <div>
        <div>
          <text for='text'>People Name</text>
          <div>
            <input
              type='text'
              onChange={(value) => {
                this.handlePeopleName(value)
              }}
              value={this.state.peopleName}
              placeholder='Please Enter People Name'
            ></input>
          </div>
          {!this.state.peopleName ? (
            <text for='text' style={{ color: 'red', fontSize: 10 }}>
              People Name Cannot Be Empty
            </text>
          ) : null}
        </div>
        <div>
          <text for='text'>People Description</text>
          <div>
            <input
              type='text'
              onChange={(value) => {
                this.handlePeopleDescription(value)
              }}
              value={this.state.peopleDescription}
              placeholder='Please Enter People Description'
            ></input>
          </div>
          {!this.state.peopleDescription ? (
            <text for='text' style={{ color: 'red', fontSize: 10 }}>
              People Description Cannot Be Empty
            </text>
          ) : null}
        </div>
        <div>
          <div>
            <text for='peopleType'>Choose People Type:</text>
          </div>
          <select
            onChange={(e) => {
              this.selectType(e)
            }}
          >
            {this.peopleType.map((item, index) => {
              return (
                <option value={item} selected={peopleType == item ? true : false}>
                  {item}
                </option>
              )
            })}
          </select>
        </div>
        <div>
          <text>People Template</text>
          <div>
            {this.peopleTemplates.map((itemType) => {
              return (
                <div className='col-md-3'>
                  <input
                    value={itemType}
                    type='radio'
                    checked={this.state.selectedPeopleTemplate == itemType}
                    onChange={() => this.selectPeopleTemplate(itemType)}
                  ></input>
                  <text for={itemType}>{itemType}</text>
                </div>
              )
            })}
          </div>
        </div>
        <div>
          <text for='text'>Cover Image :</text>
          <div>
            <input type='file' accept='image/*' onChange={this.onSelectFile} />
          </div>
          {cropImage1 && src && !peopleCoverImages.length && (
            <ReactCrop
              src={src}
              crop={crop}
              ruleOfThirds
              onImageLoaded={this.onImageLoaded}
              onComplete={this.onCropComplete}
              onChange={this.onCropChange}
            />
          )}
          {!cropImage1 ? <img style={{ maxWidth: '100%' }} src={src} /> : null}
          {!peopleCoverImages.length && src && !cropImage1 && (
            <button onClick={() => this.uploadSelectedImage('peopleCoverImages', false)}>
              Upload Image
            </button>
          )}
          {!peopleCoverImages.length && src && !cropImage1 && (
            <button onClick={() => this.setState({ cropImage1: true })}>Crop Image</button>
          )}
          {croppedImageUrl && <img style={{ maxWidth: '100%' }} src={croppedImageUrl} />}
          {src ? (
            <button onClick={() => this.removeSelectedImage('peopleCoverImages')}>
              Remove Image
            </button>
          ) : null}

          {!peopleCoverImages.length && croppedImageUrl ? (
            <button onClick={() => this.uploadSelectedImage('peopleCoverImages', true)}>
              Upload Cropped Image
            </button>
          ) : null}
          {!peopleCoverImages.length ? (
            <text for='text' style={{ color: 'red', fontSize: 10 }}>
              Please Upload Image
            </text>
          ) : null}
        </div>
        <div>
          <text for='text'>Profile Image :</text>
          <div>
            <input type='file' accept='image/*' onChange={this.onSelectFile2} />
          </div>
          {!peopleProfileImages.length && (
            <ReactCrop
              circularCrop={true}
              src={src2}
              crop={crop2}
              ruleOfThirds
              onImageLoaded={this.onImageLoaded2}
              onComplete={this.onCropComplete2}
              onChange={this.onCropChange2}
            />
          )}

          {croppedImageUrl2 && <img style={{ maxWidth: '100%' }} src={croppedImageUrl2} />}
          {src2 ? (
            <button onClick={() => this.removeSelectedImage('peopleProfileImages')}>
              Remove Image
            </button>
          ) : null}

          {!peopleProfileImages.length && croppedImageUrl2 ? (
            <button onClick={() => this.uploadSelectedImage('peopleProfileImages', true)}>
              Upload Cropped Image
            </button>
          ) : null}
          {!peopleProfileImages.length ? (
            <text for='text' style={{ color: 'red', fontSize: 10 }}>
              Please Upload Image
            </text>
          ) : null}
        </div>
      </div>
    )
  }
  render() {
    const urlParams = window.location.href.split('?')
    return (
      <div class=' row col-md-12'>
        <ToastContainer
          position='top-right'
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <details>
          <summary>General Options</summary>
          {this.renderGeneralPeopleOptions()}
          <div style={{ marginTop: '5px' }}>
            {urlParams && urlParams[1] ? (
              <div class='col-md-4'>
                {this.buttonVisibilityFunc() ? (
                  <Button onClick={() => this.handleCreatePeople()} variant='primary'>
                    Update People
                  </Button>
                ) : (
                  <Button onClick={() => this.handleCreatePeople()} variant='primary'>
                    Update People
                  </Button>
                )}
              </div>
            ) : (
              <div class='col-md-4'>
                {this.buttonVisibilityFunc() ? (
                  <Button onClick={() => this.handleCreatePeople()} variant='primary'>
                    Create People
                  </Button>
                ) : (
                  <Button disabled variant='primary'>
                    Create People
                  </Button>
                )}
              </div>
            )}
          </div>
        </details>
        {this.state.peopleID ? (
          <div>
            <input type='text' disabled value={this.state.peopleID} placeholder=''></input>

            <Link to={`/editContent?$`} target='_blank'>
              <Button variant='primary'>
                {/* <Link to={`/editContent?${PK}`} target='_blank'> */}
                <i class='fas fa-pencil-alt' />
              </Button>
            </Link>
          </div>
        ) : null}

        {this.renderTemplates()}
        {urlParams && urlParams[1] ? (
          <details>
            <summary>Config</summary>
            <div class='row' style={{ marginBottom: '5px' }}>
              <div class='col-md-2'>
                <Button
                  onClick={() => {
                    this.setState({ listCollectionModalVisible: true })
                  }}
                  variant='primary'
                  size='sm'
                >
                  Add Section
                </Button>
              </div>
              <div class='col-md-2'>
                <Button
                  variant='primary'
                  size='sm'
                  onClick={() => {
                    this.openTemplateListModal()
                  }}
                >
                  Load Template
                </Button>
              </div>
              {this.state.sectionDetails.length ? (
                <div class='col-md-2'>
                  <Button
                    variant='primary'
                    size='sm'
                    onClick={() => {
                      this.openTemplateDetailsModal()
                    }}
                  >
                    Save Template
                  </Button>
                </div>
              ) : null}
            </div>
            {this.state.sectionDetails.length ? (
              <DraggableSections
                displayToast={this.displayToast}
                refreshSections={this.refreshSections}
                updatePeopleSections={this.updatePeopleSections}
                sectionDetails={this.state.sectionDetails}
                peopleValue={`people#${urlParams && urlParams[1]}`}
                removeSection={this.removeSection}
                UpdateSectionDetails={this.UpdateSectionDetails}
                updateSortedOrder={this.updateSortedOrder}
              />
            ) : null}

            {this.renderListCollectionModal()}
            {this.renderTemplateDetailsModal()}
            {this.renderDeleteTemplateModal()}
          </details>
        ) : null}
      </div>
    )
  }
}
